import { toast } from "react-toastify";
import { callApi } from "../../../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../../../ApiHelper/ApiUrl";
import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { DatePicker } from "rsuite";
import moment from "moment";
import { Spinner } from "reactstrap";
import ErrorMessage from "../../../../../components/comman/ErrorMessage";

export default function EmployeeNomineeDetails({
  locationData,
  pageStatesMain,
  setPageStatesMain,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (locationData) {
      reset({
        nomineeRelation: locationData?.userdetail?.nomineeRelation || "",
        nomineeName: locationData?.userdetail?.nomineeName || "",
        nomineePhone: locationData?.userdetail?.nomineePhone || "",
        nomineeDob: locationData?.userdetail?.nomineeDob || "",
      });
    }
  }, []);

  const onSubmit = (data) => {
    // console.log("submitData>>>>>>>>>>", data);
    const formData = new FormData();
    formData.append("nomineeRelation", data?.nomineeRelation);
    formData.append("nomineeName", data?.nomineeName);
    formData.append("nomineePhone", data?.nomineePhone);
    formData.append("nomineeDob", data?.nomineeDob);
    formData.append("activeTab", "Nominee Details");

    const options = {
      method: "POST",
      form_data: formData,
    };
    let API =
      apiUrl?.add_employee +
      `?userId=${locationData?.id ? locationData?.id : pageStatesMain?.Id_onCreateEmp
      }`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        setPageStatesMain((prev) => ({
          ...prev,
          activeTab: 7,
        }));
      } else {
        toast.error(response?.message);
      }
    });
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-12">
            <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
              Family Details
            </h4>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="Role" className="form-label">
                Relation Type <span className="text-danger">*</span>
              </label>
              <select
                className="form-select form-control"
                aria-label="Default select example"
                {...register("nomineeRelation", {
                  required: "This field is Required",
                })}
              >
                <option value="" className="d-none">
                  Select Relation Type
                </option>
                <option value="Father">Father</option>
                <option value="Mother">Mother</option>
                <option value="Brother">Brother</option>
                <option value="Sister">Sister</option>
                <option value="Spouse">Spouse</option>
                <option value="Son">Son</option>
                <option value="Daughter">Daughter</option>
                <option value="Uncle">Uncle</option>
                <option value="Aunt">Aunt</option>
                <option value="Grandfather">Grandfather</option>
                <option value="Grandmother">Grandmother</option>
              </select>
              <ErrorMessage message={errors?.nomineeRelation?.message} />
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="Name" className="form-label">
                Nominee Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="Name"
                placeholder="Enter Name"
                {...register("nomineeName", {
                  required: "This field is Required",
                })}
              />
              <ErrorMessage message={errors?.nomineeName?.message} />
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="Number" className="form-label">
                Phone No. <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                onWheel={(e) => e.target.blur()}
                className="form-control"
                id="Number"
                placeholder="Enter Number"
                {...register("nomineePhone", {
                  required: "This field is Required",
                })}
              />
              <ErrorMessage message={errors?.nomineePhone?.message} />
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="Datebirth" className="form-label">
                Date of Birth
              </label>

              <Controller
                name="nomineeDob"
                control={control}
                rules={{
                  validate: (value) => {
                    if (!value) return true;
                    const today = new Date();
                    const dob = new Date(value);

                    let age = today.getFullYear() - dob.getFullYear();
                    const monthDiff = today.getMonth() - dob.getMonth();

                    if (
                      monthDiff < 0 ||
                      (monthDiff === 0 && today.getDate() < dob.getDate())
                    ) {
                      age--;
                    }

                    return age >= 18 || "Nominee must be at least 18 years old";
                  },
                }}
                render={({ field }) => (
                  <DatePicker size="sm"
                    {...field}
                    id="nomineeDob"
                    format="dd/MM/yyyy"
                    oneTap
                    placeholder="dd/mm/yyyy"
                    style={{ width: "100%" }}
                    value={field.value ? new Date(field.value) : null}
                    onChange={(date) => {
                      field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                    }}
                    shouldDisableDate={(date) => date > new Date()}
                    cleanable={false}
                  />
                )}
              />

              <ErrorMessage message={errors?.nomineeDob?.message} />
            </div>
          </div>

        </div>
        <div className="d-flex align-items-center justify-content-end">
          <button className="btn btn-primary px-4" type="submit">
            {isLoading ? <Spinner /> : "Save and Continue"}
          </button>
        </div>
      </form>
    </>
  );
}
